import './mail-comment.component.ajscss';

import { IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';

import { Option } from '@contact/upgrade';

import { IEpticaExctractEvent } from '../models/eptica-extract';
import { EpticaSelector } from '../models/eptica-selector';
import templateUrl from './mail-comment.component.html';

class MailCommentCtrl implements IComponentController {
  epticaEvent: IEpticaExctractEvent;
  showAttachment: boolean;
  conversational: boolean;
  contentHtml: string;

  constructor(protected readonly $log: ILogService, protected readonly $i18next: i18n, protected readonly $sce: any) {}

  $onChanges(): void {
    this.showAttachment = Option.of(this.showAttachment).getOrElse(true);
    this.conversational = this.isConversational(this.epticaEvent);
  }

  $onInit(): void {
    this.contentHtml = this.shouldTrustContent() ? this.$sce.trustAsHtml(this.epticaEvent.contentHtml) : this.epticaEvent.contentHtml;
  }

  private shouldTrustContent(): boolean {
    return (
      this.epticaEvent.selector === EpticaSelector.request_event_type_response ||
      this.epticaEvent.selector === EpticaSelector.request_event_type_outgoing_mail
    );
  }

  commentLabel(selector: string): string {
    switch (selector) {
      case EpticaSelector.request_event_type_review_requested:
      case EpticaSelector.request_event_type_approved_by_supervisor:
        return this.$i18next.t('commons:history.mail.comment_approval');
      case EpticaSelector.request_event_type_rejected_by_supervisor:
        return this.$i18next.t('commons:history.mail.comment_approval_rejected');
      default:
        return this.$i18next.t('commons:history.mail.comment');
    }
  }

  contentLabel(selector: string): string {
    switch (selector) {
      case EpticaSelector.request_event_type_review_requested:
      case EpticaSelector.request_event_type_rejected_by_supervisor:
      case EpticaSelector.request_event_type_approved_by_supervisor:
        return this.$i18next.t('commons:history.mail.content_approval');
      case EpticaSelector.request_event_ask_for_help:
        return this.$i18next.t('commons:history.mail.content_ask_for_help');
      default:
        return this.$i18next.t('commons:history.mail.content');
    }
  }

  canShow(value: string): boolean {
    return !!value && value !== '';
  }

  private isConversational(event: IEpticaExctractEvent): boolean {
    switch (event.selector) {
      case EpticaSelector.request_event_type_response:
      case EpticaSelector.request_event_type_outgoing_mail:
      case EpticaSelector.request_event_type_client_message:
      case EpticaSelector.request_event_type_opening:
      case EpticaSelector.request_event_type_monitoring:
        return true;
      default:
        return false;
    }
  }
}

export class MailComment implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    epticaEvent: '<',
    showAttachment: '<',
  };
  controller = ['$log', '$i18next', '$sce', MailCommentCtrl];
}

export default 'mailComment';
